import { useState } from "react";
import { toast } from "sonner";
import axios from "../axios";

export const useGetCampaignById = () => {
  const [loading, setLoading] = useState(false);
  const [campaign, setCampaign] = useState([]);

  const getCampaignById = async (token, id) => {
    setLoading(true);
    try {
      const res = await axios.get(`/audiences/campaign/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (res.status === 200) {
        setLoading(false);
        setCampaign(res?.data?.data);
      }
    } catch (err) {
      setLoading(false);
      toast.error(err.response.data.message);
    }
  };

  return {
    getCampaignById,
    campaign,
    setCampaign,
    loading,
    setLoading,
  };
};
